import { useGetProductLinksQuery } from 'services/api/products/home';

export default function useProductLinks(product: string, subproduct: string) {
  const { data } = useGetProductLinksQuery();
  const links = data?.data ?? [];
  const productLinks = links
    .filter((l) => l.product === product && l.subproduct === subproduct);

  return productLinks;
}
